module.exports = __webpack_public_path__ + "static/img/shopping-coupon.d608457.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopping-coupon.png
// module id = sHqP
// module chunks = 53